import { render } from "./EditAgendaView.vue?vue&type=template&id=77789c4d"
import script from "./EditAgendaView.vue?vue&type=script&lang=js"
export * from "./EditAgendaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__